import React from "react";
import { useTranslation } from "gatsby-plugin-react-i18next";

export default (props) => {
  const { contact = false, mobile, web } = props;
  const { t } = useTranslation();
  const WebTable = web;
  const MobileTable = mobile;

  return (
    <section id="prices" style={{ padding: "0px 0" }}>
      <div className="rings-bg">
        <div
          className="container"
          style={{ paddingTop: 50, paddingBottom: 50 }}
        >
          <div className="row mb-3">
            <div className="col-md-12 px-4 py-4 mb-2 text-center">
              <h1 className="subheadline2">{t("PRICESSECTION.pricesTitle")}</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              {!!web && <WebTable />}
              {!!mobile && <MobileTable />}
            </div>
          </div>

          {contact && (
            <div className="text-center mt-5">
              <h1 className="subheadline3">{t("PRICESSECTION.pricesContactForQuote")}</h1>
              <a href="#contact" className="btn btn-primary btn-lg my-3 CTA">
                {t("PRICESSECTION.pricesContactBtn")}
              </a>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
